module.exports = __webpack_public_path__ + "img/20201205_155926.31664948.jpg";